// extracted by mini-css-extract-plugin
export default {"attackModal":"AttackModal_attackModal__AgPSc"};